__turbopack_context__.v({
  "description": "CIxFwG_description",
  "root": "CIxFwG_root",
  "title": "CIxFwG_title",
});
